const routes = [
    {
        path: "/my-housing-reservations",
        component: () => import("../pages/Index.vue"),
        meta: {
            isStaff: false,
        },
    },
];

export default routes;
